"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.relativeHumanReadableDate = exports.createListingAnnotationsFromElasticSearch = exports.convertESAnnotationToGQLAnnotation = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var relativeHumanReadableDate = date => {
  var now = (0, _moment.default)();
  var then = (0, _moment.default)(date);
  var diffInHours = now.diff(then, 'hour');
  if (diffInHours <= 24) {
    var hours = Math.floor(diffInHours);
    if (hours <= 1) {
      return 'recently';
    }
    return "".concat(hours, " hour").concat(hours > 1 ? 's' : '', " ago");
  }
  if (diffInHours <= 48) {
    return 'yesterday';
  }
  return "".concat(Math.floor(now.diff(then, 'day')), " days ago");
};
exports.relativeHumanReadableDate = relativeHumanReadableDate;
var convertESAnnotationToGQLAnnotation = exports.convertESAnnotationToGQLAnnotation = function convertESAnnotationToGQLAnnotation(annotation, listingDetails) {
  var enableRelativeAnnotations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var label = annotation.label;
  var tinyLabel = annotation.label;
  var shortLabel = annotation.label;
  var badge = annotation.badge;
  switch (annotation.badge) {
    case 'new':
      if (enableRelativeAnnotations && listingDetails.publicVisibleDate) {
        label = "Added ".concat(relativeHumanReadableDate(listingDetails.publicVisibleDate));
        shortLabel = label;
      }
      break;
    case 'refreshed':
      if (enableRelativeAnnotations) {
        if (listingDetails.relistedDate) {
          label = "Promoted ".concat(relativeHumanReadableDate(listingDetails.relistedDate));
          shortLabel = label;
        }
      } else {
        label = 'New';
        shortLabel = 'New';
        badge = 'new';
        tinyLabel = 'New';
      }
      break;
    case 'underOffer':
      if (listingDetails.underOfferDate) {
        label = "Under Offer ".concat((0, _moment.default)(listingDetails.underOfferDate).format('DD/MM/YYYY'));
        shortLabel = 'Offer';
        tinyLabel = label;
      }
      break;
    default:
      break;
  }
  return {
    badge,
    label,
    tinyLabel,
    shortLabel
  };
};
var createListingAnnotationsFromElasticSearch = exports.createListingAnnotationsFromElasticSearch = function createListingAnnotationsFromElasticSearch(annotations, listingDetails) {
  var enableRelativeAnnotations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return annotations.map(annotation => convertESAnnotationToGQLAnnotation(annotation, listingDetails, enableRelativeAnnotations));
};